"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "forio": {
    "3f6c96bc": [{
      "hkey": "b99abb91",
      "slug": "forio",
      "name": "Forio",
      "primary": true,
      "skipSearch": false
    }],
    "monterone": [{
      "hkey": "b99abb91",
      "slug": "forio",
      "name": "Forio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "edc758ea": [{
      "hkey": "b99abb91",
      "slug": "forio",
      "name": "Forio",
      "primary": true,
      "skipSearch": false
    }],
    "panza": [{
      "hkey": "b99abb91",
      "slug": "forio",
      "name": "Forio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aed227a0": [{
      "hkey": "b99abb91",
      "slug": "forio",
      "name": "Forio",
      "primary": true,
      "skipSearch": false
    }],
    "scentone": [{
      "hkey": "b99abb91",
      "slug": "forio",
      "name": "Forio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;